/** Workspace names selectable in admin views (single source of truth). */
export const DATABASES = ["Lucking", "Betonbau", "Tchalabi", "Baseline", "ArabicLegal"];
